/**
 * Plugin per l'installazione dei componenti globali di WebGraphics che non hanno un plugin
 */
/** Global styles */
import '../../../world/libs/anm22_web_graphics/v1/scss/WebGraphics.scss';
/** Global components */
import WGSpinnerModal from '../components/WGSpinnerModal.vue';
import WorldObjectIcon from '../components/WorldObjectIcon.vue';
import WGFloatingButton from '../components/WGFloatingButton.vue';

import WGSearch from '../components/WGSearch.vue';
import WGSearchModule from '../storeModules/wg-search';

export default {
  install(Vue, { store }) {
    /**
     * Deve essere necessariamente passata l'istanza di vuex store
     */
     if(!store) {
      throw new Error("Please provide vuex store");
    }

    /**
     * Registrazione del modulo dello store associato al menu
     */
     store.registerModule('wg-search', WGSearchModule);

    /**
     * Registrazione componenti
     */
    Vue.component('wg-spinner-modal', WGSpinnerModal);
    Vue.component('wg-fab', WGFloatingButton);
    Vue.component('world-object-icon', WorldObjectIcon);
    Vue.component('wg-search', WGSearch);
    
  }
}